import { defaultFetchBlob } from './baseApi';

export const getDpa = async () => {
	const url = '/dpa-template/preview';
	return defaultFetchBlob(url);
};
